export const initState = {
  deductions: [],
}
